import React, {
    useContext,
    ReactNode,
    createContext,
  } from "react";
import appInsights from "../azureAppInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
  
interface LoggerContextType {
  logAppInsightsError: (error: any, eventName: string) => void;
  logAppInsightsTrace: (trace: any, severityLevel: SeverityLevel) => void;
}

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

export function LoggerContextProvider({ children }: { children: ReactNode }) {
    function logAppInsightsError(error: any, eventName: string) {
        let appInsightsError: Error = {
            name: eventName,
            message: String(error),
        };
        
        appInsights.trackException({ exception: appInsightsError });
    }

    function logAppInsightsTrace(trace: any, severityLevel: SeverityLevel) {
        let appInsightsTrace: any = {
            message: String(trace),
            severityLevel: severityLevel,
        };
        
        appInsights.trackTrace(appInsightsTrace);
    }

    return (
        <LoggerContext.Provider
        value={{
            logAppInsightsError,
            logAppInsightsTrace
        }}
        >
        {children}
        </LoggerContext.Provider>
    );
}

export function useLogger() {
    const context = useContext(LoggerContext);
    if (!context) {
        // Provide a fallback no-op function if context is not available
        return { 
            logAppInsightsError: () => {}, 
            logAppInsightsTrace: () => {} 
        };
    }
    return context;
}